import { StationGearItem, StationInfoForEvaluator } from '../types/api';

/**
 * Adds up the gear of all of a cycle's stations (P2 "Combined gear").
 * Items are matched by name, ignoring surrounding whitespace and case.
 */
export function combineGear(infos: (StationInfoForEvaluator | null | undefined)[]): StationGearItem[] {
  const totals = new Map<string, StationGearItem>();
  for (const info of infos) {
    // Stored guidance isn't trusted: one malformed entry must not take the Stations tab down.
    const gear: unknown[] = Array.isArray(info?.gear) ? info!.gear : [];
    for (const g of gear as Partial<StationGearItem>[]) {
      if (typeof g?.item !== 'string') continue;
      const name = g.item.trim();
      if (!name) continue;
      const key = name.toLocaleLowerCase();
      const qty = typeof g.quantity === 'number' && Number.isFinite(g.quantity) && g.quantity > 0 ? g.quantity : 1;
      const prev = totals.get(key);
      totals.set(key, { item: prev?.item ?? name, quantity: (prev?.quantity ?? 0) + qty });
    }
  }
  return Array.from(totals.values()).sort((a, b) => a.item.localeCompare(b.item, 'he'));
}
